angular.module('unica_event.event_services')

.factory('EventListService', function ($http, $rootScope, getBaseApiURL) {

	var eventListService = {};


	eventListService.years = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/years',
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.years;
			}

		});

	};

	eventListService.list = function (limit, offset, year) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/list',
			data: {
				limit: limit,
				offset: offset,
				year: year
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.events;
			}

		});

	};

	eventListService.searchByYear = function (year, term) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/search-year',
			data: {
				search: term,
				year: year
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.events;
			}

		});

	};


	eventListService.get = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/detail/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});
	};


	eventListService.getPreviewUrl = function (eventId) {
		return $http({
			method: 'GET',
			url: getBaseApiURL + '/event/preview-url/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	eventListService.getStagesList = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/list-stages/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.stages;
			}

		});
	};


	eventListService.exportEvent = function (eventId, data) {

		var d = data || {};

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/event/' + eventId,
			data: d
		}).then(function(result) {

			if ( result ) {

				if ( result.data.multiple ) {
					return eventListService.exportEvent( eventId, {
						chunk: true,
						other_events: result.data.other_events,
						offset: result.data.offset,
						filename: result.data.filename
					});
				} else {
					return result.data.url;
				}
			}

		});
	};


	eventListService.exportAllCustomFieldZip = function ( eventId, invitationListId )
	{
		// console.log('test');
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/all-field/' + eventId + '/' + ( invitationListId ? '/' + invitationListId : '' ),
			data: { }
		}).then(function(result) {

			if ( result && result.data.result == 'ok' ) {
				return result.data.url;
			}

			$rootScope.showWarningMsg( result.data.message );
			return null;
		});
	};


	eventListService.exportEventSmart = function (eventId, data) {

		var d = data || {};

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/event-smart/' + eventId,
			data: d
		}).then(function(result) {

			if ( result ) {

				if ( result.data.multiple ) {
					return eventListService.exportEventSmart( eventId, {
						chunk: true,
						offset: result.data.offset,
						filename: result.data.filename
					});
				} else {
					return result.data.url;
				}
			}

		});
	};


	eventListService.exportStage = function (stageId) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/stage/' + stageId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	eventListService.exportEventVideoRanking = function (eventId, data) {

		var d = data || {};

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/event-video-ranking/' + eventId,
			data: d
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	return eventListService;
});